import { Injectable } from "@angular/core";
import { Booking } from "./model/booking";
import { BusinessServiceTypes } from "./model/businessServiceTypes";
import { Payment } from "./model/payment";
import { PropertyServiceDTO } from "./model/PropertyServices";
import { Room } from "./model/room";
import { BusinessUser } from "./model/user";

const SLOTDATA = "slotdata";
const BOOKINGDATA = "booking";
const BOOKINGCITY = "bookingCity";
const BUSINESS_SERVICE = "businessservice";
const businessTypeGroupListDATA = "businessTypeGroupList";
const businessTypeListDATA = "businessTypeList";
const PAYMENT = 'payment';
const PAYMENT2 = 'payment2';
const PROPERTY_DETAILS = "PROPERTY_DETAILS";
const PROPERTY_SERVICE_DATA = "PROPERTY_SERVICE_DATA";
const PROPERTY = 'property';
const ROOMSDATA = "roomsData";
const COUNTRY = "country";
@Injectable()
export class TokenStorage {
  constructor() {}
  clearAll() {
    window.localStorage.clear();
  }
  clearBusiness() {
    window.localStorage.removeItem(BUSINESS_SERVICE);
    // window.localStorage.removeItem(BOOKSLOTDATA);
    window.localStorage.removeItem(BOOKINGDATA);
  }

  public savePaymentData(payment) {
    window.sessionStorage.removeItem(PAYMENT);
    if (payment !== null || payment !== undefined) {
      window.sessionStorage.setItem(PAYMENT, JSON.stringify(payment));
    } else {
      window.sessionStorage.setItem(PAYMENT, null);
    }
  }
  public getPropertyData(): BusinessUser {
    return JSON.parse(sessionStorage.getItem(PROPERTY));
  }
  public saveProperty(property: BusinessUser) {
    window.localStorage.removeItem(PROPERTY_DETAILS);
    if (property != null) {
      window.localStorage.setItem(PROPERTY_DETAILS, JSON.stringify(property));
    } else {
      window.localStorage.setItem(PROPERTY_DETAILS, null);
    }
  }
  
  public getPaymentData(): Payment {
    return JSON.parse(sessionStorage.getItem(PAYMENT));
  }
  clearProperty() {
    window.localStorage.removeItem(PROPERTY_DETAILS);
  }
  public getServiceData(): PropertyServiceDTO[] {
    return JSON.parse(localStorage.getItem(PROPERTY_SERVICE_DATA));
  }
  clearCountry() {
    window.localStorage.removeItem(COUNTRY);
  }
  // Property
  public savePropertyData(property) {
    window.sessionStorage.removeItem(PROPERTY);
    if (property !== null || property !== undefined) {
      window.sessionStorage.setItem(PROPERTY, JSON.stringify(property));
    } else {
      window.sessionStorage.setItem(PROPERTY, null);
    }
  }

  public saveCountry(Country) {
    window.localStorage.removeItem(COUNTRY);
    if (Country !== null || Country !== undefined) {
      window.localStorage.setItem(COUNTRY, Country);
    } else {
      window.localStorage.setItem(COUNTRY, null);
    }
  }
  public getCountry() {
    return localStorage.getItem(COUNTRY);
  }
  // BusinessTypeGroupList
  public saveBusinessTypeGroupListData(businessTypeGroupList) {
    window.localStorage.removeItem(businessTypeGroupListDATA);
    if (businessTypeGroupList !== null || businessTypeGroupList !== undefined) {
      window.localStorage.setItem(
        businessTypeGroupListDATA,
        JSON.stringify(businessTypeGroupList)
      );
    } else {
      window.localStorage.setItem(businessTypeGroupListDATA, null);
    }
  }

  public getBusinessTypeListGroupData(): any[] {
    return JSON.parse(localStorage.getItem(businessTypeGroupListDATA));
  }
  // BusinessTypeList
  public saveBusinessTypeListData(businessTypeList) {
    window.localStorage.removeItem(businessTypeListDATA);
    if (businessTypeList !== null || businessTypeList !== undefined) {
      window.localStorage.setItem(
        businessTypeListDATA,
        JSON.stringify(businessTypeList)
      );
    } else {
      window.localStorage.setItem(businessTypeListDATA, null);
    }
  }

  public getBusinessTypeListData(): any[] {
    return JSON.parse(localStorage.getItem(businessTypeListDATA));
  }

  public saveSlotData(BusinessServiceTypes: BusinessServiceTypes[]) {
    window.localStorage.removeItem(SLOTDATA);
    if (BusinessServiceTypes !== null || BusinessServiceTypes !== undefined) {
      window.localStorage.setItem(
        SLOTDATA,
        JSON.stringify(BusinessServiceTypes)
      );
    } else {
      window.localStorage.setItem(SLOTDATA, null);
    }
  }
  public getProperty(): BusinessUser {
    return JSON.parse(localStorage.getItem(PROPERTY_DETAILS));
  }
  public getSlotData(): BusinessServiceTypes[] {
    return JSON.parse(localStorage.getItem(SLOTDATA));
  }
  // PROPERTY_SERVICE_DATA
public saveServiceData(propertyServiceDTO: PropertyServiceDTO[]) {
  window.localStorage.removeItem(PROPERTY_SERVICE_DATA);
  if (propertyServiceDTO !== null || propertyServiceDTO !== undefined) {
    window.localStorage.setItem(
      PROPERTY_SERVICE_DATA,
      JSON.stringify(propertyServiceDTO)
    );
  } else {
    window.localStorage.setItem(PROPERTY_SERVICE_DATA, null);
  }
}

  // Booking
  public saveBookingData(booking: Booking) {
    window.localStorage.removeItem(BOOKINGDATA);
    if (booking !== null || booking !== undefined) {
      window.localStorage.setItem(BOOKINGDATA, JSON.stringify(booking));
    } else {
      window.localStorage.setItem(BOOKINGDATA, null);
    }
  }

  public getBookingData(): Booking {
    return JSON.parse(localStorage.getItem(BOOKINGDATA));
  }

  clearHotelBooking() {
    window.localStorage.removeItem(BOOKINGDATA);
  }
  // Booking City
  public saveBookingCity(bookingCity: string) {
    window.localStorage.removeItem(BOOKINGCITY);
    if (bookingCity !== null || bookingCity !== undefined) {
      window.localStorage.setItem(BOOKINGCITY, bookingCity);
    } else {
      window.localStorage.setItem(BOOKINGCITY, null);
    }
  }

  public getBookingCity(): string {
    return localStorage.getItem(BOOKINGCITY);
  }

  clearBookingCity() {
    window.localStorage.removeItem(BOOKINGCITY);
  }
  // Rooms Data
  public saveRoomsData(RoomsData: Room[]) {
    window.localStorage.removeItem(ROOMSDATA);
    if (RoomsData !== null || RoomsData !== undefined) {
      window.localStorage.setItem(ROOMSDATA, JSON.stringify(RoomsData));
    } else {
      window.localStorage.setItem(ROOMSDATA, null);
    }
  }

  public getRoomsData(): Room[] {
    return JSON.parse(localStorage.getItem(ROOMSDATA));
  }

  clearRoomsData() {
    window.localStorage.removeItem(ROOMSDATA);
  }
  //BusinessService
  public saveBusinessService(businessUser: BusinessUser[]) {
    window.localStorage.removeItem(BUSINESS_SERVICE);
    if (businessUser !== null || businessUser !== undefined) {
      window.localStorage.setItem(
        BUSINESS_SERVICE,
        JSON.stringify(businessUser)
      );
    } else {
      window.localStorage.setItem(BUSINESS_SERVICE, null);
    }
  }

  public getBusinessService(): BusinessUser[] {
    return JSON.parse(localStorage.getItem(BUSINESS_SERVICE));
  }
}
